import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'filepond/dist/filepond.min.css';
import Axios from 'axios';
import { CookiesProvider } from 'react-cookie';
import { Layout } from './configs/ui/constant';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import th from 'dayjs/locale/th';
dayjs.extend(buddhistEra).locale(th);

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
document.documentElement.style.setProperty('--AppColor', Layout.primary);
Axios.defaults.baseURL = `${process.env.REACT_APP_URL_ENDPOINT}`;
Axios.defaults.headers.post['Content-Type'] = 'application/json';
if (sessionStorage['token']) {
   Axios.defaults.headers.common = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`,
   };
}

const errorCodeHandler = (error) => {
   switch (error?.status) {
      case 401:
         window.location.replace('/');
         break;
      case 403:
         window.location.replace('/');
         break;
      case 400:
         let code = error.data.errorAppCode;
         switch (code) {
            case 'GSB-DashboardUser006':
               let exceptPaths = ['/', '/login'];
               let exceptPath = exceptPaths.find(
                  (el) => el === window.location.pathname,
               );
               if (!exceptPath) {
                  window.location.replace('/');
               }
            default:
         }
         break;
      default:
   }
};

Axios.interceptors.response.use(
   function (response) {
      return response;
   },
   function (error) {
      errorCodeHandler(error.response);
      return Promise.reject(error);
   },
);

ReactDOM.render(
   <React.StrictMode>
      <CookiesProvider>
         <App />
      </CookiesProvider>
   </React.StrictMode>,
   document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
